<template>
  <v-app class="split-bg">
    <v-content>
      <v-container
        fluid
        fill-height
      >
        <v-layout
          align-center
          justify-center
        >
          <v-flex
            xs12
            sm8
            md4
            lg4
          >
            <v-card class="elevation-1 pa-3">
              <v-card-text>
                <div class="layout column align-center">
                  <img
                    src="@/../public/img/logo-blue-750.png"
                    alt="GONOW"
                    height="100"
                  >
                </div>
                <v-form
                  @submit.prevent="loginHandler"
                >
                  <NumberField
                    id="companyId"
                    v-model="model.companyId"
                    prepend-inner-icon="mdi mdi-office-building"
                    :label="'会社ID'"
                    name="companyId"
                    :rules="['required', 'above1']"
                  />
                  <v-text-field
                    id="loginId"
                    v-model.trim="model.username"
                    prepend-inner-icon="mdi mdi-account"
                    name="login"
                    label="ログインID"
                    type="text"
                    :error="errors.length > 0"
                    :rules="[rules.required]"
                    @change="clearErrorsHandler"
                  />
                  <v-text-field
                    id="password"
                    v-model.trim="model.password"
                    prepend-inner-icon="mdi mdi-lock"
                    name="password"
                    label="パスワード"
                    :append-icon="visibility.password ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="visibility.password ? 'text' : 'password'"
                    :error-messages="errors"
                    :rules="[rules.required]"
                    @click:append="visibility.password = !visibility.password"
                    @change="clearErrorsHandler"
                  />
                  <v-btn
                    block
                    color="#1079ad"
                    type="submit"
                    align-self-center
                    class="loginBtn"
                    :loading="loading"
                  >
                    ログイン
                  </v-btn>
                </v-form>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { mapActions } from 'vuex'
import { NumberField } from '@/components/input'

export default {
  components: {
    NumberField
  },
  data () {
    return {
      loading: false,
      model: {
        companyId: null,
        username: '',
        password: ''
      },
      visibility: {
        password: false
      },
      errors: [],
      rules: {
        required: v => (v !== '' && v !== null) || '必須項目です。'
      }
    }
  },
  methods: {
    ...mapActions('auth', ['login']),
    async loginHandler () {
      try {
        this.loading = true
        this.errors.splice(0, this.errors.length)

        await this.login({
          companyId: this.model.companyId,
          loginKey: this.model.username,
          password: this.model.password
        })

        const next = this.$route.query.next
        if (next == null || next === '') {
          this.$router.replace('/')
        } else {
          this.$router.replace(next)
        }
      } catch (e) {
        this.loading = false
        const error = getErrorResponse(e)

        if (error) {
          this.errors.push(error.data.errorMessage)
        } else {
          this.errors.push('ログインに失敗しました')
        }
      }
    },
    clearErrorsHandler () {
      if (this.errors.length) { this.errors = [] }
    }
  }
}

export const getErrorResponse = e => {
  if (e.response == null) {
    return null
  }
  return {
    data: e.response.body,
    status: e.response.statusCode
  }
}
</script>
<style scoped lang="scss">
.split-bg {
  height: 50%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
}
.loginBtn{
  font-weight:800!important;
  font-size:1rem;color:white;
}
/deep/ .v-text-field>.v-input__control>.v-input__slot>.v-text-field__slot{
  padding-left: 10px;
}
/deep/.v-text-field__slot .v-label{
  left: 10px!important;
}
</style>
